import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="16" height="24" viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M8 4.727a1.09 1.09 0 00-1.091 1.091v5.09H1.818a1.09 1.09 0 100 2.183h5.09v5.09a1.09 1.09 0 102.183 0v-5.09h5.09a1.09 1.09 0 100-2.182h-5.09V5.818A1.09 1.09 0 008 4.728z" fill="#fff" /></svg>);